<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage">
<h1 class="title">Beautiful Star &amp; Other Stories</h1>
<h2 class="author">A.D. Swanston</h2>
<div class="logo">
<img alt="Canelo" src="media/file0.jpg" style="width:2cm;height:2cm"/>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?d0e9f0c8